import { BrowserRouter, Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "sonner";
import "@livekit/components-styles";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Layout } from "@/components/Layout";
import { MeProvider, useMe } from "@/lib/me";
import SpaceView from "@/components/space/SpaceView";
import { ChordDictionary } from "@/components/chords/ChordDictionary";
import AuthPage from "@/pages/AuthPage";
import Landing from "@/pages/Landing";
import Lobby from "@/pages/Lobby";
import LessonHub from "@/pages/LessonHub";
import Library from "@/pages/Library";
import Plans from "@/pages/Plans";
import Purchases from "@/pages/Purchases";
import { AdminSales, AdminUsers } from "@/pages/Admin";
import { PaymentCancel, PaymentSuccess } from "@/pages/PaymentResult";

const Protected = () => {
  const { pathname } = useLocation();
  return (
    <>
      <Show when="signed-in"><MeProvider><Layout /></MeProvider></Show>
      <Show when="signed-out">{pathname === "/" ? <Landing /> : <Navigate to="/sign-in" replace />}</Show>
    </>
  );
};

const AdminOnly = ({ children }) => (useMe().isAdmin ? children : <Navigate to="/" replace />);
const Space = () => { const { id } = useParams(); return <SpaceView key={id} spaceId={id} />; };
const Chords = () => (
  <div className="spotlight min-h-screen" data-testid="chords-page">
    <div className="mx-auto max-w-5xl px-4 md:px-8 py-10">
      <span className="mono-label text-yellow-300">Chord dictionary</span>
      <h1 className="mt-2 mb-8 text-4xl sm:text-5xl font-black tracking-tight">Every key. Guitar and piano.</h1>
      <ChordDictionary />
    </div>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/sign-in/*" element={<AuthPage mode="in" />} />
          <Route path="/sign-up/*" element={<AuthPage mode="up" />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Lobby />} />
            <Route path="/room/:id" element={<Space />} />
            <Route path="/lesson" element={<LessonHub />} />
            <Route path="/lesson/:id" element={<Space />} />
            <Route path="/library" element={<Library />} />
            <Route path="/chords" element={<Chords />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/purchases" element={<Purchases />} />
            <Route path="/admin/sales" element={<AdminOnly><AdminSales /></AdminOnly>} />
            <Route path="/admin/users" element={<AdminOnly><AdminUsers /></AdminOnly>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        <Toaster theme="dark" position="top-right" richColors />
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
